<div class="flex justify-center items-center">
  <span class="text-2xs sm:text-sm text-zinc-900 dark:text-zinc-50 capitalize">{{
    currentTime() | date : dateMode
  }}</span>
</div>
